type QueryStringValue = string | null | undefined | Array<string | null>

export const getFirstValueFromQueryString = (value: QueryStringValue): string | null | undefined =>
    Array.isArray(value) ? value[0] : value

export const getFilterFromQueryString = <T extends string>(
    value: QueryStringValue,
    allowedValues: readonly T[],
    defaultValue: T,
): T => {
    const filter = getFirstValueFromQueryString(value)

    if (Array.isArray(value) && value.some(item => item !== filter)) {
        return defaultValue
    }

    return allowedValues.find(allowedValue => allowedValue === filter) ?? defaultValue
}
